import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

/** Broadcasts every successful mutating API call (see ApiWriteInterceptor)
 *  so the layout editor's live-preview underlay can refresh after ANY data
 *  reaches the backend — regardless of which save path a widget uses. */
@Injectable({ providedIn: "root" })
export class LivePreviewRefreshService {
  readonly apiWrites$ = new Subject<string>();
}
